import { useEffect, useState } from "react";

const messages = [
  "Connecting to server...",
  "Loading your workspace...",
  "Preparing doubt solver...",
  "Almost ready...",
];

const Loader = () => {
  const [progress, setProgress] = useState(0);
  const [msgIndex, setMsgIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 85) {
          clearInterval(progressInterval);
          return prev;
        }
        const increment = prev < 40 ? 10 : prev < 65 ? 4 : 1;
        return Math.min(prev + increment, 85);
      });
    }, 100);

    const msgInterval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setMsgIndex((prev) => (prev + 1) % messages.length);
        setFade(true);
      }, 200);
    }, 700);

    return () => {
      clearInterval(progressInterval);
      clearInterval(msgInterval);
    };
  }, []);

  return (
    <div className="loader-overlay">
      <p className={`loader-message ${!fade ? "hidden" : ""}`}>
        {messages[msgIndex]}
      </p>
      <div className="loader-progress-track">
        <div
          className="loader-progress-bar"
          style={{ "--progress": `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default Loader;
